import { ca } from '@cian/analytics';

export function trackShowRatingsBlock() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'show_rating',
    useLastProducts: true,
  });
}

export function trackShowAwardsBlock() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardBuilder',
    action: 'show_awards',
    useLastProducts: true,
  });
}
